<template lang="pug">
  .b-user-select
    ._contacts(v-if="items.length")
      UserTile._contact(
        v-for="user in items"
        :key="user.id"
        :user="user"
        @click.native="toggleContact(user)"
        :class="{ selected: isSelected(user) }"
        )
    EmptyList(v-else) {{ emptyLabel }}
    ._buttons(v-if="inPopup")
      Btn(v-if="isClearable" grey @click="onClear") Очистить
      Btn(v-if="inPopup" @click="onClose") Закрыть
</template>

<script>
import BaseSelect from '@/components/BaseSelect.vue';
import BaseTooltip from '@/components/BaseTooltip.vue';
import UserAvatar from '@/components/UserAvatar.vue';
import UserTile from '@/components/UserTile.vue';
import EmptyList from '@/components/ui/EmptyList.vue';

export default {
  name: 'UserSelectTile',
  components: { UserTile, UserAvatar, BaseTooltip, BaseSelect, EmptyList }, // eslint-disable-line
  model: { prop: 'selected', event: 'change' },
  props: {
    items: Array,
    selected: [Array, Object],
    multiple: Boolean,
    inPopup: Boolean,
    emptyLabel: String,
    isClearable: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    isSelected(contact) {
      return this.multiple
        ? this.selected.find((item) => item['@id'] === contact['@id'])
        : this.selected?.['@id'] === contact['@id'];
    },
    toggleContact(contact) {
      if (this.multiple) {
        const updatedValue = this.isSelected(contact)
          ? this.selected.filter((item) => item.id !== contact.id)
          : [...this.selected, contact];

        this.$emit('change', updatedValue);
      } else {
        this.$emit('change', contact);
        this.$emit('close');
      }
    },
    onClose() {
      this.$emit('close');
    },
    onClear() {
      if (this.multiple) {
        this.$emit('change', []);
      } else {
        this.$emit('change', null);
        this.$emit('close');
      }
    },
  },
};
</script>

<style scoped lang="scss">
.user-select {
  display: flex;
  flex-direction: column;
  position: relative;

  &__contacts {
    overflow: auto;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    align-self: flex-start;
    margin: 13px 0 15px;
    gap: 8px;
  }

  &__contact {
    cursor: pointer;
    padding: 6px 15px 6px 7px;
    border-radius: 6px;
    background-color: var(--main-bg);
    transition: background-color .3s;
    font-weight: 500;

    &.selected {
      color: var(--color-white);
      background-color: var(--color-green-st);
    }

    &::v-deep {
      .name {
        display: block !important;
      }
      .body {
        display: flex !important;
      }
    }
  }

  &__buttons {
    display: flex;
    justify-content: flex-end;
    gap: 8px;
    margin-top: 20px;
  }

  @media (max-width: 500px) {
    &__contacts {
      margin-top: 0;
    }

    &__contact {
      width: 100%;
    }

    &__buttons {
      flex-direction: column;
    }
  }
}
</style>
